import {Box, Center, Stack} from '@chakra-ui/react';
import {GeoLink} from 'components/action/GeoLink';
import {FormStatusError} from 'components/ApiError';
import {required} from 'components/form';
import {GeoButton} from 'components/forms/GeoButton';
import {GeoCheckbox} from 'components/forms/GeoCheckbox';
import {GeoInput} from 'components/forms/GeoInput';
import {useTranslation} from 'modules/i18n';
import React from 'react';
import {Form} from 'utils/form';
import {useResponsive} from 'utils/useResponsive';
import {getCachedAuthenticationUsername} from '../provider/token';
import {useLogin} from './hooks';

export const LoginForm: React.FC = () => {
	const {t} = useTranslation();
	const {isMobile} = useResponsive();
	const {loginOperation} = useLogin();
	// if the user haved checked the `rememberMe` option
	const _cachedUserName: string = getCachedAuthenticationUsername();

	const renderGroupButton = () => {
		return (
			<Stack spacing={5} direction={isMobile ? 'column-reverse' : 'row'}>
				<Box pl={4} mt={isMobile ? 0 : 4}>
					<GeoLink
						color='geoGray.100'
						fontWeight={500}
						label={t('auth.forgottenPassword')}
						to='authPasswordResetRequest'
					/>
				</Box>
				<Box>
					<Center>
						<GeoButton
							id='submit-login'
							type='submit'
							isLoading={loginOperation.loading}
						>
							{t('auth.signIn')}
						</GeoButton>
					</Center>
				</Box>
			</Stack>
		);
	};
	const renderPosition = () => {
		return isMobile ? (
			<Center marginTop={6}>{renderGroupButton()}</Center>
		) : (
			<Box marginTop={6} sx={{float: 'right'}}>
				{renderGroupButton()}
			</Box>
		);
	};

	return (
		<Form onSubmit={loginOperation.execute}>
			<Box marginTop={5}>
				<GeoInput
					name='username'
					label={t('auth.email')}
					type='email'
					data-cy='input-username'
					defaultValue={_cachedUserName}
					placeholder={t('auth.placeholderEmail')}
					validation={required('errors.required')}
				/>
			</Box>
			<Box marginTop={4}>
				<GeoInput
					name='password'
					label={t('auth.password')}
					type='password'
					data-cy='input-password'
					placeholder={t('auth.placeholderPassword')}
					validation={required('errors.required')}
				/>
			</Box>
			<Box marginTop={5}>
				<GeoCheckbox
					defaultChecked={_cachedUserName !== undefined}
					name='rememberMe'
					label={t('auth.rememberMe')}
					data-cy='checkbox-rememberMe'
				/>
			</Box>
			<Box marginTop={5} sx={{float: 'right'}} />

			<FormStatusError error={loginOperation.error} />
			{renderPosition()}
		</Form>
	);
};
